import { render, staticRenderFns } from "./Pendencies.vue?vue&type=template&id=44e12c94"
import script from "./Pendencies.vue?vue&type=script&lang=js"
export * from "./Pendencies.vue?vue&type=script&lang=js"
import style0 from "./Pendencies.vue?vue&type=style&index=0&id=44e12c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports